/**
 * Task completion feedback: one of the three retro "done" voices in `sfx`,
 * never the same one twice in a row. Kept as its own entry point because the
 * tick mutation must call it synchronously inside the click's activation.
 */

import { playSfx } from "./sfx";

export function playTaskCompletionSound(): void {
  playSfx("done");
}
